module.exports = __webpack_public_path__ + "img/Z60_03.432f41fb.jpg";